// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g8rI2kurCv6Th3oWYzHN{border-radius:14px}.AYHJA8Nann4DKj5y2BOb{display:flex;justify-content:center !important}", "",{"version":3,"sources":["webpack://./src/styles/Card.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA,CAGF,sBACE,YAAA,CACA,iCAAA","sourcesContent":[".card {\n  border-radius: 14px;\n}\n\n.modal {\n  display: flex;\n  justify-content: center !important; // Fuck semantic\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "g8rI2kurCv6Th3oWYzHN",
	"modal": "AYHJA8Nann4DKj5y2BOb"
};
export default ___CSS_LOADER_EXPORT___;
